<script lang="ts" setup>
import SkrButton from '@/components/button/SkrButton.vue'
import CardWithIcon from '@/components/dashboard/CardWithIcon.vue'

defineProps<{
  loading: boolean
}>()

const emit = defineEmits<{
  action: []
}>()

const { t } = useI18n()
const { smAndDown } = useDisplay()
const { track } = useAnalytics()

onMounted(() => {
  track(ANALYTICS_EVENTS.STARTER_PLAN_DIALOG_VIEWED)
})

const isOpen = ref<boolean>(true)

watch(isOpen, newValue => {
  if (!newValue) {
    emit('action')
  }
})
</script>

<template>
  <v-dialog
    v-model="isOpen"
    scrim="skribbleu"
    max-width="700"
    scroll-strategy="block"
    scrollable
    data-cy="welcome_to_starter_plan"
    class="welcome-dialog"
  >
    <div class="welcome-dialog__container pa-12">
      <skr-heading level="1" class="welcome-dialog__title font-weight-bold mb-6">{{
        t('home.welcome_starter.title')
      }}</skr-heading>
      <p class="welcome-dialog__info text-pre-wrap pb-5 mb-0">{{ t('home.welcome_starter.description') }}</p>

      <div class="d-flex gap-6 justify-center" :class="smAndDown ? 'flex-column mt-10' : 'flex-row mt-16'">
        <card-with-icon
          class="welcome-dialog__description"
          icon="custom:free_to_sign"
          bg-color="purple-light"
          color="purple-dark"
        >
          <span class="font-weight-bold">{{ t('home.welcome_starter.card_free.part_1') }}</span>
          {{ t('home.welcome_starter.card_free.part_2') }}
        </card-with-icon>
        <card-with-icon icon="custom:pay_to_sign" bg-color="grey-bg-7" color="skribbleu">
          <strong>{{ t('home.welcome_starter.card_pay_per_use.part_1') }}</strong>
          {{ t('home.welcome_starter.card_pay_per_use.part_2') }}
        </card-with-icon>
      </div>

      <skr-button
        type="primary"
        color="grey-light-5"
        class="welcome-dialog__button d-flex mt-13"
        :ripple="false"
        size="lg"
        data-cy="close_dialog_button"
        @click="emit('action')"
        >{{ t('home.welcome_starter.cta') }}</skr-button
      >
    </div>
  </v-dialog>
</template>

<style lang="scss" scoped>
.welcome-dialog {
  &__container {
    border-radius: 30px;
    background-color: $c-white;
    color: $c-skribbleu;
    box-shadow: 0 10px 78px 21px rgba(40, 62, 102, 0.03);
  }

  &__title {
    font-size: 2.375rem;
  }
  &__info {
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
  &__button {
    justify-self: center;
    box-shadow: none;
  }
  &__description {
    color: $c-purple-dark;
  }
  :deep(.v-overlay__scrim) {
    opacity: 0.2;
  }
}
</style>
